import React, { useEffect } from "react";
import { connect } from "react-redux";
import {
  deleteProductCategory,
  getProductCategories,
} from "../../../redux/Actions/ProductCategoryAction";
import DeleteModal from "../../Modal/DeleteModal";

const DeleteCategory = (props) => {
  const { deleteCategory, isDeleting, deleteSuccess, id, getCategories } =
    props;

  useEffect(
    () => {
      if (deleteSuccess) {
        props.closeModal();
        getCategories(1, 10);
      }
    }, // eslint-disable-next-line
    [deleteSuccess]
  );

  const handleDelete = (id) => {
    deleteCategory(id);
  };

  return (
    <DeleteModal
      displayModal={props.displayModal}
      closeModal={props.closeModal}
      title={"Delete this category?"}
      width={"463px"}
      text={"Delete"}
      onClick={() => handleDelete(id)}
      disabled={isDeleting}
      isLoading={isDeleting}
      loadingText={"Deleting..."}
      children={
        "Once you delete this category, it won’t be possible to undo this action. Delete category?"
      }
    />
  );
};

const mapStateToProps = (state) => ({
  isDeleting: state.productcategory.isDeleting,
  deleteSuccess: state.productcategory.deleteSuccess,
});

const mapDispatchToProps = (dispatch) => ({
  deleteCategory: (id) => dispatch(deleteProductCategory(id)),
  getCategories: (page, limit) => dispatch(getProductCategories(page, limit)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DeleteCategory);
